import { Box, Button, Typography, useTheme } from "@mui/material";
import { COMMITMENT_COPY } from "../onboardingSteps";
import { BrandWordmark } from "../assets/BrandWordmark";
import { displayTitleSx, primaryButtonSx, textBody } from "./stepStyles";

/**
 * The identity commitment beat: pressing "I'm ready" IS the commitment — no
 * yes/no binary, no wellness-app theatrics.
 */

interface CommitmentStepProps {
  onContinue: () => void;
}

export const CommitmentStep = ({ onContinue }: CommitmentStepProps) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";

  return (
    <Box
      sx={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        textAlign: "center",
        gap: 2.5,
      }}
    >
      <BrandWordmark />
      <Typography sx={displayTitleSx(isDark)}>{COMMITMENT_COPY.title}</Typography>
      <Box>
        {/* Blank lines in the copy become real paragraph breaks. */}
        {COMMITMENT_COPY.body.split("\n\n").map((paragraph, index) => (
          <Typography
            key={paragraph}
            sx={{
              mt: index === 0 ? 0 : 2,
              fontSize: "1rem",
              lineHeight: 1.55,
              color: textBody(isDark),
              maxWidth: 330,
              mx: "auto",
            }}
          >
            {paragraph}
          </Typography>
        ))}
      </Box>
      <Box sx={{ mt: 2 }}>
        <Button fullWidth onClick={onContinue} sx={primaryButtonSx}>
          {COMMITMENT_COPY.cta}
        </Button>
      </Box>
    </Box>
  );
};
